import {createSelector} from 'reselect'
import {LockStatus, LockStatusVal} from '@modifi/enums'

import {selectOnboardingCompany} from './entity'

export const selectCompanyExternalId = createSelector(
  selectOnboardingCompany,
  company => company?.externalId || null
)
export const selectCompanyActivationStatus = createSelector(
  selectOnboardingCompany,
  company => company?.activation?.activationStatus || null
)

export const selectCurrentCompaniesCountryCode = createSelector(
  selectOnboardingCompany,
  company => company?.address?.countryCode || null
)

export const selectCurrentCompaniesCountryCodeLowerCased = createSelector(
  selectCurrentCompaniesCountryCode,
  countryCode => countryCode?.toLowerCase() || null
)

export const selectCompanyName = createSelector(
  selectOnboardingCompany,
  company => company?.address?.companyName || null
)

const selectCompanyLockStatus: (state: Record<string, any>) => LockStatusVal | null =
  createSelector(selectOnboardingCompany, company => company?.lockStatus || null)
export const selectCompanyIsLocked = createSelector(
  selectCompanyLockStatus,
  currentLockStatus => currentLockStatus === LockStatus.LOCKED
)

export const selectCompanyAddress = createSelector(
  selectOnboardingCompany,
  company => company?.address
)

export const selectCompanyLegalForm = createSelector(
  selectOnboardingCompany,
  company => company?.legalForm
)

export const selectCompanyFoundationDate = createSelector(
  selectOnboardingCompany,
  company => company?.foundationDate
)

export const selectCompanyIndustry = createSelector(
  selectOnboardingCompany,
  company => company?.industry
)
